<template>
  <div class="jc-page-container">
    <div class="jc-page-header">
      <el-page-header title="下级渠道商客户" />
    </div>

    <div class="jc-page-content">
      <div class="jc-page-card">
        <div class="jc-container-table">
          <div class="jc-container-table-actionBar">
            <el-form
              class="jc-table-actionBar-item"
              :inline="true"
              :model="form"
            >
              <el-form-item label="渠道商名称：">
                <el-input v-model.trim="form.distributorName"></el-input>
              </el-form-item>

              <el-form-item label="关联时间：">
                <el-date-picker
                  v-model="daterange"
                  type="daterange"
                  placeholder="选择日期范围"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="query(query)">查询</el-button>
              </el-form-item>

              <el-form-item>
                <el-button @click="exportList" class="jc-button-icon"
                  ><i class="jc-icon-download"></i>
                </el-button>
              </el-form-item>
            </el-form>
          </div>

          <el-table :data="tableData" style="width: 100%" class="form-loading">
            <el-table-column prop="distributorName" label="渠道商名称">
              <template slot-scope="scope">{{
                scope.row.distributorName | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="pin" label="客户PIN">
              <template slot-scope="scope">{{
                scope.row.pin | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="loginName" label="客户账号名">
              <template slot-scope="scope">{{
                scope.row.loginName | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="name" label="客户名称">
              <template slot-scope="scope">{{
                scope.row.name | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="relTime" label="关联时间">
              <template slot-scope="scope">{{
                scope.row.relTime | filterParams
              }}</template>
            </el-table-column>
          </el-table>

          <div class="jc-container-table-actionBar" v-if="total > 10">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="form.pageIndex"
              :page-sizes="[10, 20, 50]"
              :page-size="form.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  querySubCustomerList,
  exportSubCustomerList,
} from '@/api/distributor-api.js'
import { getDate } from '@/utils'
import routerMixins from '@/mixins/router-mixins.js'
export default {
  mixins: [routerMixins],
  data() {
    return {
      currentPage1: 1,
      form: {
        distributorName: '',
        pageSize: 10,
        pageIndex: 1,
        startRelTime: '',
        endRelTime: '',
      },
      daterange: '',
      total: 0,
      tableData: [],
    }
  },
  created() {
    this.query()
  },
  watch: {
    daterange(curVal) {
      this.form.startRelTime =
        (curVal[0] && getDate(curVal[0]).txt_ymd + ' 00:00:00') || ''
      this.form.endRelTime =
        (curVal[1] && getDate(curVal[1]).txt_ymd + ' 23:59:59') || ''
    },
  },
  methods: {
    handleSizeChange(val) {
      this.form.pageSize = val
      this.query()
    },
    handleCurrentChange(val) {
      this.form.pageIndex = val
      this.query()
    },
    async query(query) {
      if (query) {
        this.form.pageIndex = 1
      }
      try {
        let { result } = await querySubCustomerList(this.form)
        this.tableData = result && result.result
        this.total =
          result && result.pagination && result.pagination.numberRecords
      } catch (e) {
        console.log(e)
        this.tableData = []
        this.total = 0
      }
    },
    async exportList() {
      try {
        let { result } = await exportSubCustomerList(this.form)
        window.location.href = eval("'" + result.uri + "'")
      } catch (e) {
        console.log(e)
      }
    },
  },
}
</script>
